import {z} from 'zod';

import {translations} from 'presentation/translations-new';
import {parse, format} from 'date-fns';
import {ptBR} from 'date-fns/locale';

const {invalidEmail, invalidCellphone, emailNotEqual, cellphoneNotEqual, invalidBirthday} =
	translations['pt-br'].publicFlow.errors;

export const formSchema = z
	.object({
		birthday: z
			.string()
			.min(10, {message: invalidBirthday})
			.transform(val => parse(val, 'P', 0, {locale: ptBR}))
			.pipe(z.date().max(new Date(), {message: invalidBirthday}))
			.transform(val => format(val, 'P', {locale: ptBR})),
		email: z.string().email(invalidEmail),
		confirmEmail: z.string(),
		cellphone: z
			.string()
			.min(15, invalidCellphone)
			.transform(val => val.replace(/\D/g, '')),
		confirmCellphone: z.string().transform(val => val.replace(/\D/g, '')),
	})
	.superRefine((val, ctx) => {
		if (val.confirmEmail !== val.email) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: emailNotEqual,
				path: ['confirmEmail'],
			});
		}
		if (val.confirmCellphone !== val.cellphone) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: cellphoneNotEqual,
				path: ['confirmCellphone'],
			});
		}
		if (!val.birthday) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: invalidBirthday,
				path: ['birthday'],
			});
		}
	});

export type IFormData = z.infer<typeof formSchema>;
